import React from 'react';

const SubmitButton = ({children, disabled, ...rest}) => (
    <button type="submit" className="btn btn-primary submit-button" disabled={disabled} {...rest}>{children}</button>
);

export default SubmitButton;
